/**
 * EmptyState Component
 * Clean empty state with icon and suggestions
 */

import React from 'react';
import './EmptyState.css';

interface EmptyStateProps {
  title: string;
  message: string;
  suggestions?: string[];
  onSuggestionClick?: (suggestion: string) => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  title, 
  message, 
  suggestions,
  onSuggestionClick 
}) => {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8v4M12 16h.01" />
        </svg>
      </div>
      
      <div className="empty-state-title">{title}</div>
      <div className="empty-state-message">{message}</div>
      
      {suggestions && suggestions.length > 0 && (
        <div className="empty-state-suggestions">
          <div className="empty-state-suggestions-label">Try:</div>
          <div className="empty-state-chips">
            {suggestions.map((suggestion, index) => (
              <button
                key={index}
                className="empty-state-chip"
                onClick={() => onSuggestionClick?.(suggestion)}
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
